import mediaManager from '@anm/helpers/media/mediaManager';
import { useEffect, useState } from 'react';

const filterDevices = (devices: MediaDeviceInfo[]) => devices.filter(({ deviceId }) => !!deviceId);
const useMediaDevicesControls = () => {
  const [webcams, setWebcams] = useState<MediaDeviceInfo[]>(() => mediaManager().webcams.devices());
  const [mics, setMics] = useState<MediaDeviceInfo[]>(() => mediaManager().mics.devices());
  const [speakers, setSpeakers] = useState<MediaDeviceInfo[]>(() => mediaManager().speakers.devices());

  const resetWebcams = () => setWebcams(filterDevices(mediaManager().webcams.devices()));
  const resetMics = () => setMics(filterDevices(mediaManager().mics.devices()));
  const resetSpeakers = () => setSpeakers(filterDevices(mediaManager().speakers.devices()));

  useEffect(() => {
    resetWebcams();
    resetMics();
    resetSpeakers();

    return mediaManager().changeEvent.on(event => {
      if (event.webcamsChanged) resetWebcams();
      if (event.micsChanged) resetMics();
      if (event.speakersChanged) resetSpeakers();
    });
  }, []);

  return {
    mics,
    webcams,
    speakers
  };
};

export default useMediaDevicesControls;
